import React, { useMemo, useState } from 'react'

import { AgGridReact } from 'ag-grid-react'
import Select from 'react-select'

import { groupedOptions } from './dealViews'
import KeyModal from '@/key-components/KeyModal'
import { useGetWorkQueuesFieldsQuery } from '@/services/application'
import { Option } from '@/types/components'

const ColumnsSelectModal = ({ isModalOpen, setIsModalOpen, gridRef }) => {
  const [selectedSection, setSelectedSection] = useState<Option>()
  const [search, setSearch] = useState<string>('')
  const { data: workQueuesFields } = useGetWorkQueuesFieldsQuery()
  const hiddenFields = ['kickback']

  const fieldsToShow = useMemo(() => {
    let fields = workQueuesFields

    if (selectedSection)
      fields = workQueuesFields.filter((field) => field.section === selectedSection.value)

    if (search) {
      fields = fields.filter(
        (field) => field.label.toLowerCase().includes(search.toLowerCase()) && field.section
      )
    }

    // Filter out the "kickback" field
    fields = fields?.filter((field) => !hiddenFields.includes(field.value))

    return fields
  }, [selectedSection, search])

  const handleColumnChanged = (event) => {
    const selected = event.target.value
    const grid: AgGridReact = gridRef.current
    if (!grid) return

    const isColumnVisible = grid.columnApi.getColumn(selected).isVisible()
    grid.columnApi.setColumnVisible(selected, !isColumnVisible)
  }

  const deselectAll = () => {
    const fileNameField = 'name'
    const fieldNames = fieldsToShow
      ?.map(({ value }) => value)
      ?.filter((field) => field !== fileNameField) // do not hide file name field

    const grid: AgGridReact = gridRef.current
    if (!grid || !fieldNames) return

    grid.columnApi.setColumnsVisible(fieldNames, false)
  }

  return (
    <KeyModal
      isModalOpen={isModalOpen}
      title='Field Chooser'
      onModalClose={() => setIsModalOpen(false)}
    >
      <div className='h-[500px]'>
        <div className='flex gap-4 p-4 items-center border-b'>
          <Select<Option>
            name='applicationStates'
            value={selectedSection}
            options={groupedOptions}
            className='w-1/4'
            data-test='columns-dropdown'
            placeholder='View Data Point Groups'
            onChange={(option) => setSelectedSection(option)}
            isClearable
          />
          <input
            type='search'
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            name='fileName'
            placeholder='Search for a specific data point or group'
            className='h-[38px] border border-gray-300 rounded w-[360px]'
            data-test='search-by-column-name'
          />
          <button
            className='ml-auto bg-blue-900 text-white rounded p-2'
            data-test='deselect-all-btn'
            onClick={deselectAll}
          >
            Deselect All
          </button>
        </div>
        <div className='grid grid-cols-4 p-4'>
          {fieldsToShow?.map(({ value, label }) => (
            <div
              key={value}
              className='flex gap-2 my-2'
            >
              <label htmlFor={value}>
                <input
                  type='checkbox'
                  value={value}
                  id={value}
                  checked={gridRef?.current?.columnApi?.getColumn(value)?.isVisible()}
                  className='border rounded p-2 disabled:bg-gray-200 border-indigo-100 cursor-pointer'
                  onChange={handleColumnChanged}
                />
                <span className='ml-2 text-sm'>{label}</span>
              </label>
            </div>
          ))}
        </div>
      </div>
    </KeyModal>
  )
}

export default ColumnsSelectModal
